import { EventsConfig } from "@energylab/shared-components/constants/config/eventsConfig";

export const eventsConfig: EventsConfig = {
    defaultView: "list",
    viewOptions: [],
    hideFeaturedEvents: true
};
